import React from 'react';
import {Create,TextInput ,number, SimpleForm , SaveButton , Toolbar , 
    translate,ReferenceInput,SelectInput ,ImageInput , ImageField} from 'react-admin';
import Button from '@material-ui/core/Button';
const CsCreateToolbar = translate(({ onCancel, translate, ...props }) => (
    <Toolbar {...props}>
        <SaveButton />
        <Button onClick={onCancel}>{translate('ra.action.cancel')}</Button>
    </Toolbar>
));
const validateDate = [number('YYYYMMDD 형식으로 숫자만 입력해 주세요')];

const CsCreate = ({ onCancel, ...props }) => (
    
    <Create title="  " {...props}>
        <SimpleForm toolbar ={<CsCreateToolbar onCancel={onCancel} />}>
            <TextInput validate={validateDate} source ='date' label="일자" />

            <ReferenceInput source ='customerId' perPage={500} label="고객사" reference="customers" >
                <SelectInput  optionText="name"/>
            </ReferenceInput>
            <ReferenceInput source ='csCategoryId' label="CS분류" reference="commonCodes" filter={{ type: '09' }}>
                <SelectInput  optionText="desc" />
            </ReferenceInput>
            {/* <SelectInput source ='csCategoryId' label="CS분류" choices={[
                    { id: '51', name: '배송' },
                    { id: '52', name: '음식' },
                    { id: '53', name: '위생' },
                    { id: '54', name: '기타' },
                ]}></SelectInput> */}
            <TextInput source ='desc' label="내용" resettable multiline />
            <ImageInput source="csFileInput" label="CS이미지" multiple={true} accept="image/*">
                <ImageField source="src" title="title" />
            </ImageInput>
        </SimpleForm>
    </Create>
);

export default CsCreate;
